module.exports = __webpack_public_path__ + "static/media/commit-app_2screen.2bd257c4.png";